import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import React from "react";
import { useFormContext } from "react-hook-form";

type ControlledTextareaProps = React.ComponentProps<"textarea"> & {
  name: string;
  label?: string;
  noLabel?: boolean;
  className?: string;
};

export default function ControlledTextarea({
  name,
  placeholder,
  noLabel,
  label,
  className,
  ...props
}: ControlledTextareaProps) {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-col">
          {!noLabel && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <Textarea
              placeholder={placeholder}
              className={className}
              {...field}
              {...props}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}
